import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { Student } from '@/models/student/student';

// クラス編成のD&D用データ構造
export class StudentsByClass implements Serializable<StudentsByClass> {
  schoolClass: SchoolClass;
  students: Student[] = [];

  deserialize(input: any): StudentsByClass {
    this.schoolClass = input.schoolClass;
    if (input.students && Array.isArray(input.students)) {
      this.students = input.students.map((student: Student) => new Student().deserialize(student));
    }

    return this;
  }
  get noSelectedStudents(): Student[] {
    return this.students.filter((student: Student) => {
      return !student.selected;
    });
  }
}
